export default {
    'ERROR-GET-REVIEW-STATUS-BY-UUID': {
        'ERROR-UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'UUID fourni est invalide.",
                en: 'The provided UUID is invalid.',
            },
        },
        'ERROR-REVIEW-REQUEST-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucune demande d'avis trouvée.",
                en: 'No review request found.',
            },
            // redirectPath: '/review-request-not-found',
        },
        'ERROR-REVIEW-REQUEST-AND-RECIPIENT-FOUND': {
            actionType: 'toast',
            message: {
                fr: 'La demande de révision et le destinataire ont déjà été trouvés.',
                en: 'The review request and recipient have already been found.',
            },
        },
        'ERROR-MISMATCH-USER-AND-RECIPIENT': {
            actionType: 'redirect',
            message: {
                fr: 'Vous n\'avez pas accès à cette page',
                en: 'You do not have access to this page',
            },
            redirectPath: '/',
        },
    },
    'ERROR-GET-REVIEW-STATUS-BY-UUID-PUBLIC': {
        'ERROR-UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'UUID fourni est invalide.",
                en: 'The provided UUID is invalid.',
            },
        },
        'ERROR-REVIEW-REQUEST-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucune demande d'avis trouvée.",
                en: 'No review request found.',
            },
            // redirectPath: '/review-request-not-found',
        },
        'ERROR-REVIEW-REQUEST-AND-RECIPIENT-FOUND': {
            actionType: 'toast',
            message: {
                fr: 'Erreur dans la requête',
                en: 'Error in the request',
            },
        },
    },
    'ERROR-CREATE-REVIEW': {
        'ERROR-UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'UUID fourni est invalide.",
                en: 'The provided UUID is invalid.',
            },
        },
        'ERROR-REVIEW-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: 'Vous avez déjà soumis un avis pour cette demande.',
                en: 'You have already submitted a review for this request.',
            },
        },
        'ERROR-REVIEW-REQUEST-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucune demande d'avis trouvée.",
                en: 'No review request found.',
            },
            // redirectPath: '/review-request-not-found',
        },
    },
    'ERROR-CREATE-REVIEW-PUBLIC': {
        'ERROR-UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'UUID fourni est invalide.",
                en: 'The provided UUID is invalid.',
            },
        },
        'ERROR-EMAIL-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'adresse e-mail est invalide.",
                en: 'The email address is invalid.',
            },
        },
        'ERROR-RATING-INVALID': {
            actionType: 'toast',
            message: {
                fr: 'La note doit être comprise entre 1 et 5.',
                en: 'The rating must be between 1 and 5.',
            },
        },
        'ERROR-PROFILE-PICTURE-URL-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'URL de l'image de profil est invalide.",
                en: 'The profile picture URL is invalid.',
            },
        },
        'ERROR-REVIEW-REQUEST-NOT-FOUND': {
            actionType: 'toad',
            message: {
                fr: "Aucune demande d'avis trouvée.",
                en: 'No review request found.',
            },
            // redirectPath: '/review-request-not-found',
        },
    },
};
